import { ComponentType } from 'react';

import { entityRole, entityTeamLegalRole } from '@/api/entity/types';
import { Permission } from '@/api/permissions';
import { TeamAssociateStatusType } from '@/api/types';
import { EntityRoleRequestsTab } from '@/shared/modules/role-requests';

import EntityRolesBoard from './modules/roles';
import { UserDetails } from './modules/user-details';

export type TeamDashboardTab = {
  name: string;
  label: string;
  component: ComponentType;
  permission?: Permission | readonly Permission[];
};

export const tabsData: TeamDashboardTab[] = [
  { name: 'user-details', label: 'Members', component: UserDetails },
  // Tab names are URL values (`?tab=permissions`), so they are part of the page
  // contract — the label changed to match the board, the key deliberately did not.
  {
    name: 'permissions',
    label: 'Roles',
    component: EntityRolesBoard,
    permission: Permission.EntityViewRoles,
  },
  {
    name: 'requests',
    label: 'Requests',
    component: EntityRoleRequestsTab,
    permission: [Permission.EntityApproveRoleRequests, Permission.EntityViewRoles],
  },
];

export const colorByTeamStatus: Record<TeamAssociateStatusType, string> = {
  Pending: '#E27625',
  SignedUp: '#82C1FF',
  WaitingForApproval: '#F9D151',
  Rejected: '#F52D1F',
  Verified: '#39CA88',
  Blocked: '#32465E',
};

export const tooltipByTeamStatus: Record<TeamAssociateStatusType, string> = {
  Pending:
    'This user has received an invitation email, but has not created their Gamma Prime profile yet.',
  SignedUp: 'This user has registered but has not yet completed KYC or their profile.',
  WaitingForApproval: `This user already has a Gamma Prime profile. Waiting for the user to approve their invitation to this Entity and complete their KYC, investor's questionnaire and profile.`,
  Rejected: 'This user has rejected an invitation to become a team member of your Entity.',
  Verified: 'This user is a fully verified team member of your Entity.',
  Blocked: 'This user is blocked.',
};

export const entityRoleList = Object.entries(entityRole).map(([key, value]) => ({
  label: value,
  value: key,
}));
export const isDirectorList = [
  { label: 'Yes', value: entityTeamLegalRole.Director },
  { label: 'No', value: entityTeamLegalRole.TeamMember },
];
